export const BRAND = 'EBOOKSTORE™';
export const PRODUCT_NAME = 'Mega Pack Instructor de Detailing';
export const CHECKOUT_URL = 'https://mega-pack-instructor-de-detailing.impultienda.ar/checkout';
export const OFFER_SECTION_ID = 'oferta';
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/oZRjbMVp5uvrncwwcJC8dp/mockup.png';
export const PRICE = '$19.990 ARS';
export const CONTACT_EMAIL = 'ebookstore028@gmail.com';

export const quickStats = [
  { value: '6', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos prácticos' },
  { value: '20', label: 'Clases listas para adaptar' },
  { value: '50', label: 'Escenarios y desafíos' },
  { value: '150', label: 'Preguntas de evaluación' },
];

export const galleryImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/tkd4AW3TaDiAxJRS6vAPPY/Captura_de_pantalla_2026-10-18_120841.png',
    alt: 'Volumen 01: Método y planificación del instructor de detailing',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tdxpERgKNvgcUEy7C3zp34/Captura_de_pantalla_2026-10-18_120951.png',
    alt: 'Mapa del taller de capacitación: estaciones, área de demostración y de explicación',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ceNgNK5wdE6HQoVcgCsVuN/Captura_de_pantalla_2026-10-18_121043.png',
    alt: 'Matriz para observar al alumno durante la práctica',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5Gq98k7fme4EFjDbKExX89/Captura_de_pantalla_2026-10-18_121209.png',
    alt: 'Planilla de control de materiales antes de cada clase',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4P4PdFckqTtnCDyBzLSbVm/Captura_de_pantalla_2026-10-18_121232.png',
    alt: 'Registro de observaciones del alumno',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1nD1nmxWBwsdyYK2u3sqD9/Captura_de_pantalla_2026-10-18_121401.png',
    alt: 'Planificador: una clase completa en una sola página',
  },
];

export const withoutSystem = [
  'Buscar información para cada clase.',
  'Preparar actividades desde cero.',
  'Crear evaluaciones y planillas.',
  'Organizar prácticas por separado.',
  'Repetir el mismo proceso antes de cada capacitación.',
];

export const withSystem = [
  '6 volúmenes organizados.',
  '20 clases listas para adaptar.',
  '50 escenarios y desafíos.',
  '150 preguntas de evaluación.',
  'Atlas visual y recursos didácticos.',
  'Planillas para organizar y hacer seguimiento.',
];

export const faqs = [
  {
    q: '¿Necesito ser instructor certificado para usar el Mega Pack?',
    a: 'No. Está pensado como recurso educativo para instructores, detailers, capacitadores y academias. No reemplaza certificaciones o requisitos profesionales que puedan corresponder.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Es 100% digital. Después de la compra recibís acceso al material para utilizarlo desde tus dispositivos.',
  },
  {
    q: '¿Puedo adaptar las clases?',
    a: 'Sí. Podés modificar tiempos, objetivos, actividades y nivel de dificultad según tus alumnos y modalidad de capacitación.',
  },
  {
    q: '¿Incluye material práctico?',
    a: 'Sí. Incluye clases, demostraciones, prácticas, ejercicios, escenarios, checklists y evaluaciones.',
  },
  {
    q: '¿Incluye evaluaciones?',
    a: 'Sí. Recibís 150 preguntas, modelos de evaluación y herramientas para registrar el progreso de los alumnos.',
  },
  {
    q: '¿Los 5 bonos están incluidos?',
    a: 'Sí. Los 5 bonos están incluidos junto con los 6 volúmenes principales.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago para acceder al producto completo.',
  },
  {
    q: '¿El Mega Pack me convierte automáticamente en instructor?',
    a: 'No. El material ayuda a organizar y mejorar tus capacitaciones, pero no reemplaza experiencia técnica, formación profesional o certificaciones que puedan corresponder.',
  },
];

export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba' },
  { name: 'Lucía Fernández', city: 'Rosario' },
  { name: 'Diego Romero', city: 'Mendoza' },
  { name: 'Carolina Sosa', city: 'La Plata' },
  { name: 'Federico Álvarez', city: 'San Miguel de Tucumán' },
  { name: 'Valeria Díaz', city: 'Mar del Plata' },
  { name: 'Javier Medina', city: 'Salta' },
  { name: 'Sebastián Molina', city: 'Neuquén' },
  { name: 'Lorena Torres', city: 'Santa Fe' },
  { name: 'Pablo Ruiz', city: 'Bahía Blanca' },
  { name: 'Gabriela Benítez', city: 'Posadas' },
  { name: 'Nicolás Herrera', city: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Corrientes' },
  { name: 'Matías Acosta', city: 'San Juan' },
  { name: 'Natalia Aguirre', city: 'Resistencia' },
  { name: 'Hernán Giménez', city: 'Río Cuarto' },
];
